import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailRegexValidator(): ValidatorFn {
  const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+[a-zA-Z0-9_]@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/);

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && !emailRegex.test(value)) {
      return { invalidEmail: true };
    }
    return null;
  };
}
